import React, { useEffect, useId, useRef } from 'react';
import { createPortal } from 'react-dom';
import './CharacterDraftSelector.css';

export default function CharacterDraftDialogs({ dialog, pending, error, onConfirm, onCancel }) {
    const id = useId();
    const panel = useRef(null);
    const latest = useRef({ pending, onCancel });
    latest.current = { pending, onCancel };
    useEffect(() => {
        const previous = document.activeElement;
        const element = panel.current;
        const focusable = () => [...element.querySelectorAll('input:not(:disabled), button:not(:disabled)')];
        (focusable()[0] || element).focus();
        const contain = event => {
            if (!element.contains(event.target)) (focusable()[0] || element).focus();
        };
        const keyboard = event => {
            if (event.key === 'Escape') {
                event.preventDefault();
                if (!latest.current.pending) latest.current.onCancel();
            }
            if (event.key !== 'Tab') return;
            const items = focusable();
            const index = items.indexOf(document.activeElement);
            if (!items.length || (event.shiftKey ? index <= 0 : index < 0 || index === items.length - 1)) {
                event.preventDefault();
                (event.shiftKey ? items[items.length - 1] : items[0])?.focus();
            }
        };
        document.addEventListener('focusin', contain);
        document.addEventListener('keydown', keyboard);
        return () => {
            document.removeEventListener('focusin', contain);
            document.removeEventListener('keydown', keyboard);
            if (previous?.isConnected) previous.focus();
        };
    }, []);
    const submit = choice => { if (!pending) onConfirm({ choice }); };
    return createPortal(<div className="draft-dialog-overlay">
        <section className="draft-dialog" role="dialog" aria-modal="true" aria-labelledby={`${id}-title`}
            aria-describedby={`${id}-description`} aria-busy={pending} tabIndex={-1} ref={panel}>
            <h2 id={`${id}-title`}>Save current build before loading?</h2>
            <p id={`${id}-description`}>
                {`Your current build has no matching saved draft. Load “${dialog.target.name}”?`}
            </p>
            <p>{dialog.snapshotName
                ? `Save your current build as “${dialog.snapshotName}” before loading.`
                : 'Your current build will use a generated name if you save it.'}</p>
            <form onSubmit={event => { event.preventDefault(); submit('save'); }}>
                {error && <p role="alert">{error}</p>}
                {pending && <p role="status">Please wait…</p>}
                <div className="draft-actions">
                    <button type="submit" disabled={pending}>Save Current Build &amp; Load</button>
                    <button type="button" disabled={pending} onClick={() => submit('discard')}>Load Without Saving</button>
                    <button type="button" disabled={pending} onClick={onCancel}>Cancel</button>
                </div>
            </form>
        </section>
    </div>, document.body);
}
